/* Floty · código de referência no WhatsApp da loja.
   Guarda o identificador do clique do anúncio (gclid/gbraid/wbraid/fbclid/utm) ao chegar na loja e, quando o cliente
   abre o WhatsApp, acrescenta "(ref: CL-XXXX)" ao texto e regista código -> clique. Assim a conversa do Agilize volta
   para a campanha que a gerou. À prova de falhas: qualquer erro devolve o comportamento original do botão. */
(function () {
  'use strict';
  var CHAVE = 'floty_clk', DIAS = 90, API = 'https://lp.floty.com/api/ref.php';
  var CAMPOS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var RE_WA = /(api\.whatsapp\.com\/send|wa\.me\/|web\.whatsapp\.com\/send)/i;

  function le() { try { var o = JSON.parse(localStorage.getItem(CHAVE) || 'null'); if (o && Date.now() - o.ts < DIAS * 864e5) return o; } catch (e) { /* sem armazenamento */ } return null; }
  function grava(o) { try { localStorage.setItem(CHAVE, JSON.stringify(o)); } catch (e) { /* sem armazenamento */ } }

  // 1) ao chegar: guarda o clique do anúncio (o mais recente vale)
  try {
    var q = new URLSearchParams(location.search), novo = {}, tem = false;
    CAMPOS.forEach(function (k) { var v = q.get(k); if (v) { novo[k] = v.slice(0, 300); tem = true; } });
    if (tem) { novo.ts = Date.now(); novo.landing = (location.pathname + location.search).slice(0, 300); grava(novo); }
  } catch (e) { /* segue */ }

  function codigo() { var l = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', c = ''; for (var i = 0; i < 4; i++) c += l[Math.floor(Math.random() * l.length)]; return 'CL-' + c; }

  // 2) ao abrir o WhatsApp: acrescenta o código e regista
  function marca(url) {
    try {
      if (!url || !RE_WA.test(String(url))) return url;
      var u = new URL(String(url), location.href), txt = u.searchParams.get('text') || '';
      if (/\(ref: CL-[A-Z0-9]{4}\)/.test(txt)) return url;
      var cod = codigo(), clk = le() || {};
      u.searchParams.set('text', (txt ? txt + '\n\n' : '') + '(ref: ' + cod + ')');
      var dados = { code: cod, origem: 'loja', pagina: (location.pathname).slice(0, 300) };
      CAMPOS.forEach(function (k) { if (clk[k]) dados[k] = clk[k]; });
      if (clk.landing) dados.landing = clk.landing;
      if (clk.ts) dados.clique_ts = new Date(clk.ts).toISOString();
      try {
        var corpo = JSON.stringify(dados);
        if (!(navigator.sendBeacon && navigator.sendBeacon(API, new Blob([corpo], { type: 'text/plain' })))) {
          fetch(API, { method: 'POST', body: corpo, keepalive: true, mode: 'no-cors' });
        }
      } catch (e) { /* o WhatsApp abre mesmo assim */ }
      return u.toString();
    } catch (e) { return url; }
  }

  // botão da app (abre com window.open)
  try {
    var abreOriginal = window.open;
    window.open = function (url) { var a = Array.prototype.slice.call(arguments); a[0] = marca(url); return abreOriginal.apply(window, a); };
  } catch (e) { /* segue */ }

  // links para o WhatsApp: botão da app (shadow DOM) e botões/rodapé do tema
  document.addEventListener('click', function (ev) {
    try {
      // o botão da app fica dentro de um shadow DOM: procurar o link real no caminho do evento
      var cam = ev.composedPath ? ev.composedPath() : [ev.target], a = null;
      for (var i = 0; i < cam.length; i++) { var el = cam[i]; if (el && el.tagName === 'A' && el.href) { a = el; break; } }
      if (a && RE_WA.test(a.href)) a.href = marca(a.href);
    } catch (e) { /* segue */ }
  }, true);
})();
